module.exports = __webpack_public_path__ + "img/scene5-7.5b240960.png";